import 'spiegel_base/Resources/Private/Javascript/index.js'
import 'node_modules/cookieconsent'

if (typeof (Cookiebot) === 'undefined') {
  window.addEventListener('load', function () {
    window.cookieconsent.initialise({
      container: document.querySelector('body'),
      palette: {
        popup: {
          background: '#121210',
          text: '#ffffff'
        },
        button: {
          background: '#ea3e00',
          text: '#ffffff'
        }
      },
      content: {
        message: 'Wir verwenden Cookies, um die Funktion unserer Website zu gewährleisten, Inhalte und Werbung zu personalisieren und unseren Datenverkehr zu analysieren.',
        dismiss: 'Verstanden',
        link: 'Datenschutz',
        href: '/datenschutz'
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  window.Cookiebot = window.Cookiebot || {}
  if (typeof (window.Cookiebot.renew) === 'undefined') {
    window.Cookiebot.renew = function () {
      window.alert('Bitte passen Sie die Tracking-Einstellungen Ihres Browsers an. Unsere Website verwendet Cookiebot zum Verwalten von Cookies. Leider scheint Cookiebot von Ihrem Browser geblockt zu werden.')
    }
  }
})
